// rxjs-extension/reactives/luxon.ts
import { DateTime } from "luxon";
import { BehaviorSubject } from "rxjs";
var DateTimeBehaviorSubject = class extends BehaviorSubject {
  constructor(defaultDateTime) {
    super(defaultDateTime ?? DateTime.now());
  }
  next(value) {
    if (value instanceof DateTime)
      super.next(value);
    else if (value instanceof Date)
      super.next(DateTime.fromJSDate(value));
    else
      super.next(DateTime.fromJSDate(new Date(value)));
  }
  get(unit) {
    return this.getValue().get(unit);
  }
  set(values) {
    const newImmutableDateTime = this.getValue()?.set(values);
    this.next(newImmutableDateTime);
    return newImmutableDateTime;
  }
  plus(amount) {
    const newImmutableDateTime = this.getValue()?.plus(amount);
    this.next(newImmutableDateTime);
    return newImmutableDateTime;
  }
  minus(amount) {
    const newImmutableDateTime = this.getValue().minus(amount);
    this.next(newImmutableDateTime);
    return newImmutableDateTime;
  }
};
export {
  DateTimeBehaviorSubject as default
};
